import InfoIcon from '@mui/icons-material/Info';
import { Button } from '@mui/material';
import { useState } from 'react';
import DialogAdaptive from './DialogAdaptive';
import DialogContentAdaptive from './DialogContentAdaptive';
import StyledCardTitleBar from './StyledCardTitleBar';
import StyledDialogActions from './StyledDialogActions';

const MoreInfoDialog = ({ title, children }: { title: string; children: React.ReactNode }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button variant="outlined" size="small" onClick={handleOpen} startIcon={<InfoIcon />}>
                More Info
            </Button>
            {/* Dialog for more information */}
            {/* The Dialog is opened when the button is clicked */}
            <DialogAdaptive
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth={true}
                scroll="paper"
                aria-labelledby="more-info-dialog-title"
            >
                <StyledCardTitleBar title={title} />
                <DialogContentAdaptive>{children}</DialogContentAdaptive>
                <StyledDialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </StyledDialogActions>
            </DialogAdaptive>
        </>
    );
};

export default MoreInfoDialog;
